import type { FC } from 'react';
import { Helmet } from 'react-helmet';
import { canonicalUrlCleanup } from '../../utils/canonical-url-cleanup';
import { type PrefetchUrlConfig, getPrefetchUrls } from '../../utils/performance-utils';

const urlsToPrefetch: PrefetchUrlConfig[] = [
    { hostname: 'assets.surlatable.com', addCrossOrigin: false },
];

export const SearchHead: FC<{
    canonicalUrl: string;
}> = ({ canonicalUrl }) => (
    <Helmet>
        <link
            rel="canonical"
            href={canonicalUrlCleanup(canonicalUrl)}
            data-testid="search-canonical-link"
        />
        {/* @ts-expect-error: __PRODUCTION__ variable will be replaced by webpack */}
        {__PRODUCTION__ ? getPrefetchUrls(urlsToPrefetch) : null}
    </Helmet>
);
